import React from 'react'
import SelectableCard from 'components/JarCard/SelectableCard'
import useCurrentUserEntities from 'hooks/useCurrentUserEntities'
import { Grid, Typography, Box } from '@material-ui/core'
import { updateUser } from 'actions/users'

import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { stopTithing, startTithing } from 'actions/campaigns'
import { useDispatch } from 'react-redux'
import useFormExpanded from 'hooks/useFormExpanded'
import { FormProvider } from 'react-hook-form'
import TithingPercentage from 'components/Fields/TithingPercentage'

export default function SetupTithing({ completeStep, Footer }) {
  const titheableJars = useCurrentUserEntities('campaigns').filter(jar => jar.tithingEnabled)
  const tithedJarIds = useCurrentUserProp('tithedJars')
  const userId = useCurrentUserProp('id')
  const dispatch = useDispatch()
  const tithedJars = useCurrentUserEntities('campaigns', 'tithedJars')
  const formMethods = useFormExpanded({ mode: 'onChange' })
  const { hasErrors, watch, handleSubmit } = formMethods
  const watchedTithingPercentage = watch('tithingPercentage', useCurrentUserProp('tithingPercentage'))

  function handleStopTithing(jarId) {
    dispatch(stopTithing(userId, jarId))
  }

  function handleStartTithing(jarId) {
    dispatch(startTithing(userId, jarId))
  }

  function saveAndContinue({ tithingPercentage }) {
    dispatch(updateUser(userId, { tithingPercentage })).then(() => {
      completeStep('Setup Tithing')
    })
  }

  const footerText = () => {
    if (hasErrors) {
      return
    }

    if (tithedJars.length > 0) {
      return (
        <React.Fragment>
          With your current settings, you will tithe <strong>{watchedTithingPercentage}%</strong>
          {tithedJarIds.length > 1 ? (
            <span> split between <strong>{tithedJarIds.length}</strong> funds</span>
          ) : (
            <span> to <strong>{tithedJars[0].name}</strong> fund</span>
          )}
        </React.Fragment>
      )
    }

    return 'You are not tithing to any funds right now. You can update this later!'
  }

  const userDonationSumsByJar = useCurrentUserProp('donationSumsByJar')

  return (
    <FormProvider { ...formMethods }>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4} component={Box} textAlign='center'>
          <Typography paragraph variant='h4' component='h1'>Setup Tithing</Typography>
          <Typography variant='body2' gutterBottom>
            Set the percentage of your income you'd like to tithe from each detected paycheck.
          </Typography>
          <Typography variant='body2' gutterBottom>
            Don't worry about this ever catching you off guard; you approve each tithe manually before it's deducted.
          </Typography>
          <TithingPercentage margin='normal' />
        </Grid>

        <Grid container xs={12} sm={6} md={8} item spacing={1} justifyContent='center'>
          <Grid item xs={12}>
            <Typography variant='body2' align='center' gutterBottom>
              Choose one or more of the funds to tithe to. Our primary fund has been selected by default.
            </Typography>
            <Typography variant='body2' align='center'>
              <i>Deselect all funds to proceed without tithing.</i>
            </Typography>
          </Grid>
          {titheableJars.map((jar) => (
            <Grid key={jar.id} item xs={12} md={6}>
              <SelectableCard
                {...jar}
                userContributionsTotal={userDonationSumsByJar[jar.id] || 0}
                selected={tithedJarIds.includes(jar.id)}
                onSelect={() => handleStartTithing(jar.id)}
                onDeselect={() => handleStopTithing(jar.id)}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Footer additionalText={footerText()} handleClickNext={handleSubmit(saveAndContinue)} disableNextButton={hasErrors} />
    </FormProvider>
  )
}
